<template>
    <div class="container mt-3 orders container_products" style="min-height:600px">
        <div class="d-flex navbar-expand-lg py-2 o_portal_navbar mt-4">
            <ol class="o_portal_submenu breadcrumb mb-0 py-2 flex-grow-1">
                <li class="breadcrumb-item ms-1">
                    <router-link :to="{
                        name: 'home',
                        params: { storeName: this.$store.storeName, lang: $i18n.locale },
                    }" :aria-label="$t('home')" :title="$t('home')">
                        <i class="fa fa-home"></i></router-link>
                </li>
                <li class="breadcrumb-item active ">
                    {{ $t('orders') }}
                </li>
            </ol>
        </div>

          <div v-if="loading">
      <hollow-dots-spinner class="loading_card_spinner" :animation-duration="1000" :dot-size="35" :dots-num="3"
        color="var(--primary-color)" />

    </div>
        <table v-else>
            <thead>
                <tr>
                    <th> {{ $t('Order no.') }} </th>
                    <th>{{ $t('Date') }}</th>
                    <th>{{ $t('total') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in this.DBitems" :key="index">
                    <td><router-link 
                    class="invoice_number"
                    :to="{ name: 'invoice', params: { storeName: $store.storeName, id: item.id } }"># {{
                            item.invoice_id }}</router-link></td>
                    <td>{{ item.date }}</td>
                    <td>{{ item.total_price }} {{ unit }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { HalfCircleSpinner, HollowDotsSpinner, CirclesToRhombusesSpinner } from "epic-spinners";

export default {
    components: {
        HalfCircleSpinner,
        HollowDotsSpinner,
        CirclesToRhombusesSpinner
    },
    data: function () {
        return {
            DBitems: null,
            DBitems1: null,

            loading: false,
            loading1: false,

            activeTab: false,
            page: 1,
            count: 0,
            pageSize: 6,

            page1: 1,
            count1: 0,
            pageSize1: 6,

            langChange: "",
            unit: this.$store.state.unit,
        };
    },
    created() {
        if (this.$router.currentRoute.name == "myOrdersSuccess") {
            let AllCookies = this.$cookies.keys();
            for (let i = 0; i < AllCookies.length; i++) {
                if (AllCookies[i].split("/")[0] == this.$store.storeName) {
                    this.$cookies.remove(AllCookies[i]);
                    ////PartialPrice

                }
            }
        }
        this.$store.state.topbar = 'topbar_dark';
        this.$store.state.navbar = 'navbar_dark navbar_top';

        this.unit = this.$store.state.unit;
        if (this.$i18n.locale == 'ar') {
            this.unit = this.$store.state.unitAR;
        }
        else {
            this.unit = this.$store.state.unit;
        }
        this.loading = true;
        this.axios
            .get(
                this.$store.state.base_api_url +
                this.$store.storeName +
                "/orders/current",
                {
                    headers: {
                        "Accept-Language": this.$i18n.locale,
                        Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName)
                    }
                }
            )
            .then(response => {
                this.DBitems = response.data.data.orders;
                this.count = response.data.meta.total;
            })
            .then(() => (this.loading = false))
            .catch(error => {
                if (error.response.status == "401") {
                    this.$localStorage.remove(this.$store.storeName);
                    window.location.href = "/store";

                }
            });
        ///prev
        this.loading1 = true;
        this.axios
            .get(
                this.$store.state.base_api_url +
                this.$store.storeName +
                "/orders/previous",
                {
                    headers: {
                        "Accept-Language": this.$i18n.locale,
                        Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName)
                    }
                }
            )
            .then(response => {
                this.DBitems1 = response.data.data.orders;
                this.count1 = response.data.meta.total;
            })
            .then(() => (this.loading1 = false))
            .catch(error => {
                if (error.response.status == "401") {
                    this.$localStorage.remove(this.$store.storeName);
                    window.location.href = "/store";

                }
            });
    },
    methods: {
        updatedata() {
            this.unit = this.$store.state.unit;
            if (this.$i18n.locale == 'ar') {
                this.unit = this.$store.state.unitAR;
            }
            else {
                this.unit = this.$store.state.unit;
            }
            this.loading = true;


            ///orders
            this.loading1 = true;
            this.axios
                .get(
                    this.$store.state.base_api_url +
                    this.$store.storeName +
                    "/orders",
                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale,
                            Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName)
                        }
                    }
                )
                .then(response => {
                    this.DBitems = response.data.data.orders;
                    this.count = response.data.meta.total;
                    this.pageSize = response.data.meta.per_page;

                })
                .then(() => (this.loading1 = false))
                .catch(error => {
                    if (error.response.status == "401") {
                        this.$localStorage.remove(this.$store.storeName);
                        window.location.href = "/store";

                    }
                });
            this.$store.state.langchange = false;
        },
        retrieveTutorials() {
            const params = this.page;

            this.loading = true;
            this.axios
                .get(
                    this.$store.state.base_api_url +
                    this.$store.storeName +
                    "/orders?page=" +
                    params,
                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale,
                            Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName)
                        }
                    }
                )
                .then(response => {
                    this.DBitems = response.data.data.orders;
                    //this.count = response.data.meta.total;
                    this.pageSize = response.data.meta.per_page;

                })
                .then(() => (this.loading = false))
                .catch(error => {
                    if (error.response.status == "401") {
                        this.$localStorage.remove(this.$store.storeName);
                        window.location.href = "/store";

                    }
                });
            /*.catch((e) => {
                console.log(params);
                console.log(e);
              });*/
        },
        handlePageChange(value) {
            this.page = value;
            this.retrieveTutorials();
        },
        retrieveTutorials1() {
            const params = this.page1;

            this.loading1 = true;
            this.axios
                .get(
                    this.$store.state.base_api_url +
                    this.$store.storeName +
                    "/orders?page=" +
                    params,
                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale,
                            Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName)
                        }
                    }
                )
                .then(response => {
                    this.DBitems = response.data.data.orders;
                    //this.count = response.data.meta.total;
                    this.pageSize = response.data.meta.per_page;

                })
                .then(() => (this.loading1 = false))
                .catch(error => {
                    if (error.response.status == "401") {
                        this.$localStorage.remove(this.$store.storeName);
                        window.location.href = "/store";

                    }
                });
            /*.catch((e) => {
                console.log(params);
                console.log(e);
              });*/
        },
        handlePageChange(value) {
            this.page = value;
            this.retrieveTutorials();
        }
    },

    watch:
    {
        langChange() {
            this.unit = this.$store.state.unit;
            if (this.$i18n.locale == 'ar') {
                this.unit = this.$store.state.unitAR;
            }
            else {
                this.unit = this.$store.state.unit;
            }
            this.loading = true;
            this.axios
                .get(
                    this.$store.state.base_api_url +
                    this.$store.storeName +
                    "/orders",
                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale,
                            Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName)
                        }
                    }
                )
                .then(response => {
                    this.DBitems = response.data.data.orders;
                    this.count = response.data.meta.total;
                })
                .then(() => (this.loading = false))
                .catch(error => {
                    if (error.response.status == "401") {
                        this.$localStorage.remove(this.$store.storeName);
                        window.location.href = "/store";

                    }
                });
        }
    },
    updated() {
        this.langChange = this.$i18n.locale
    },
};
</script>